import { ctx as L20NContext, Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { POWER_CONTROL_UNIT_EVENT_TYPE_L20N } from '../../_config/consts';

export function getPcuEventTypeL20nKey(eventType) {
  return POWER_CONTROL_UNIT_EVENT_TYPE_L20N[eventType] || null;
}

export function formatPcuEventTypeLabel(eventType) {
  const key = getPcuEventTypeL20nKey(eventType);
  if (key) {
    return L20NContext.getSync(key);
  }
  return eventType || '-';
}

export function renderPcuEventType(eventType) {
  const key = getPcuEventTypeL20nKey(eventType);
  if (key) {
    return <Entity entity={key} />;
  }
  return eventType || '-';
}
